import React from "react";
import styles from "./Hero.module.css";
import { heroImage } from "../assets";
import "../i18n";
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const handleScroll = (id: string) => {
    const target = document.querySelector(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.heroInner}>
        <div className={styles.heroContent}>
          <div className={styles.heroBadge}>{t('hero.badge')}</div>
          <h1 className={styles.heroTitle}>
            {t('hero.title').split('\n').map((line: string, i: number) => (
              <React.Fragment key={i}>{line}{i < t('hero.title').split('\n').length - 1 && <br />}</React.Fragment>
            ))}
            <span className={styles.heroAccent}>
              {/* accent stays as part of title in translations if needed */}
            </span>
          </h1>
          <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
          <div className={styles.heroActions}>
            <button
              onClick={() => handleScroll("#catalog")}
              className={styles.btnPrimary}
            >
              {t('hero.choose')}
            </button>
            <button
              onClick={() => handleScroll("#steps")}
              className={styles.btnSecondary}
            >
              {t('hero.how')}
            </button>
          </div>
        </div>

        <div className={styles.heroImageWrap}>
          <div className={styles.glow} />
          <img src={heroImage} alt="" className={styles.heroImage} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
